const state = {
  messages: []
}

const mutations = {
  addMessage (state, value) {
    state.messages.push(value)
  },

  removeMessage (state, index) {
    state.messages.splice(index, 1)
  }
}

const actions = {
  addMessage ({ commit, rootGetters }, code) {
    commit('addMessage', rootGetters['error/status'](code))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
